export default {
    clientId: 'saber', // 客户端id
    clientSecret: 'saber_secret', // 客户端密钥
    tokenHeader: 'tjd-Auth',
    appid: 'wx49297614b6358656', // 微信APPID
    domain: 'http://jwc.xnai.edu.cn'
}